const swiper = new Swiper('.swiper-container', {
    // Optional parameters
    slidesPerView: 1.05,
    spaceBetween: 24,
    freeMode: true,
    loop: false,

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-right',
        prevEl: '.swiper-button-left',
    },
    breakpoints: {
        1536: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 2.4,
            spaceBetween: 40,
        },
        768: {
            slidesPerView: 1.75,
            spaceBetween: 32,
            freeMode: true,
        },

        640: {
            slidesPerView: 1.40,
            spaceBetween: 32,
            freeMode: true,
        },
    }
});